import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { OutcomeCaseStudyArticle } from "@/components/resources/OutcomeCaseStudyArticle";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { articleJsonLdForPillar } from "@/components/site/PillarArticle";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import body from "../../content/resources/petwell-magento-shopify-plus-migration-case-study.es.md?raw";

const PATH = "/es/recursos/caso-petwell-migracion-magento";
const ALT = "/resources/petwell-magento-migration-case-study";
const TITLE = "Petwell: migración de 10.000+ SKUs de Magento a Shopify Plus en 8 semanas";
const META_TITLE = "Caso Petwell: Magento a Shopify Plus · Shugert";
const DESCRIPTION = "Cómo Petwell migró 10.000+ SKUs de Magento a Shopify Plus en 8 semanas con cero downtime, histórico, taxonomía y redirect mapping.";
const PUBLISHED = "2026-08-20T14:30:00.000Z";
const MODIFIED = "2026-08-20T14:30:00.000Z";

const SOURCES = [
  { label: "Perfil de Shugert Marketing", publisher: "Shopify", href: "https://www.shopify.com/partners/directory/partner/shugert-marketing" },
  { label: "Petwell", publisher: "Petwell", href: "https://petwell.co.uk/" },
  { label: "Migrar a Shopify", publisher: "Shopify Help Center", href: "https://help.shopify.com/en/manual/migrating-to-shopify" },
  { label: "Migraciones de sitio con cambio de URL", publisher: "Google Search Central", href: "https://developers.google.com/search/docs/crawling-indexing/site-move-with-url-changes" },
];

const RELATED = [
  { label: "Caso Llantas Cavazos", href: "/es/recursos/caso-llantas-cavazos-migracion" },
  { label: "Migración a Shopify", href: "/es/migracion-shopify" },
  { label: "Agencia Shopify Plus", href: "/es/agencia-shopify-plus" },
  { label: "Todos los casos Shopify", href: "/es/proyectos" },
];

export const Route = createFileRoute("/es/recursos/caso-petwell-migracion-magento")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es", title: META_TITLE, description: DESCRIPTION, path: PATH, altPath: ALT, type: "article",
    author: "Samuel Noriega", articleAuthor: "Samuel Noriega", articleSection: "Caso de migración Shopify", publishedTime: PUBLISHED, modifiedTime: MODIFIED,
    jsonLd: [
      articleJsonLdForPillar({ title: TITLE, description: DESCRIPTION, path: PATH, publishedTime: PUBLISHED, modifiedTime: MODIFIED, section: "Caso de migración Shopify" }),
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Proyectos", path: "/es/proyectos" }, { name: "Caso Petwell", path: PATH }]),
    ],
  }),
  component: () => (
    <SiteShell>
      <OutcomeCaseStudyArticle
        locale="es" path={PATH} title={TITLE}
        excerpt="Cómo una operación Magento de más de 10.000 SKUs migró a Shopify Plus en ocho semanas preservando integridad de catálogo, datos históricos, intención de URLs y disponibilidad continua."
        body={body} updated="Agosto de 2026" publishedAt={PUBLISHED} modifiedAt={MODIFIED} readingMinutes={10}
        focus="Cómo Petwell trató taxonomía, clientes y pedidos históricos, redirect mapping, QA y cutover como una sola migración controlada de Magento a Shopify Plus."
        audience="Merchants Magento establecidos que evalúan Shopify Plus y para los que catálogo, continuidad SEO y riesgo de downtime importan más que reproducir la plataforma legacy pantalla por pantalla."
        sources={SOURCES} related={RELATED}
        category="Caso de migración Magento a Shopify Plus" backLabel="← Proyectos" backHref="/es/proyectos"
        cta={{ eyebrow: "Replatform controlado", title: "Migra el negocio, no solo el export de productos.", body: "Definimos catálogo, histórico, redirects, integraciones, QA y cutover juntos para que el replatform tenga criterios de aceptación claros antes del lanzamiento.", label: "Solicitar alcance de migración", href: "/es/cotizacion?intent=rebuild&challenge=migrating&source=petwell-case-study" }}
      />
    </SiteShell>
  ),
});
